// One style for every top nav in the app.
//
// Nine files each hand-rolled their own <nav>, which is why the same two bugs
// had to be fixed page by page twice: the status-bar inset (the logo drew under
// the iOS clock) and pinning (the bar scrolled away on some pages and not
// others). Both live here now, so a nav built from this cannot miss either.
//
// The translucent blur matches LeagueNavBar, which is the bar users see most.
//
// The fill is a token, not a literal, so a bar inside a themed page darkens
// with it. The alpha lives in the token for the same reason it did here: an
// opaque colour would lose the blur. Outside a themed page the token resolves
// to its light value, so untouched routes look exactly as before.
//
// paddingY is kept as the base of the paddingTop calc rather than replaced by
// it, so on web and Android, where env(safe-area-inset-top) resolves to 0, the
// bar keeps its original padding.
export function topNavStyle({ paddingX = 20, paddingY = 12 } = {}) {
  return {
    position: 'sticky',
    top: 0,
    zIndex: 40,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'var(--color-chrome)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    borderBottom: '1px solid var(--color-chrome-border)',
    padding: `${paddingY}px ${paddingX}px`,
    paddingTop: `calc(${paddingY}px + env(safe-area-inset-top))`,
  };
}

export default topNavStyle;
